import { connect } from 'react-redux';
import Soal from '../../../views/Kurikulum/Soal/Soal.kurikulum.view';
import { getParamOptions } from '../../../states/thunks/options.thunk';
import { saveAnnouncement, listAnnouncement, viewAnnouncement, editAnnouncement, deleteAnnouncement } from '../../../states/thunks/academics.thunk';

function mapStateToProps(state) {
    return {
      user: state.user,
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      getParamOptions: (payload, type) => dispatch(getParamOptions(payload, type)),
      handleSaveAnnouncement: (payload, goback) => dispatch(saveAnnouncement(payload, goback)),
      handleListAnnouncement: (payload, goback) => dispatch(listAnnouncement(payload, goback)),
      handleViewAnnouncement: (payload, goback) => dispatch(viewAnnouncement(payload, goback)),
      // handleEditAnnouncement: (payload, goback) => dispatch(editAnnouncement(payload, goback)),
      handleDeleteAnnouncement: (payload, goback) => dispatch(deleteAnnouncement(payload, goback)),
    };
  }

  export default connect(mapStateToProps, mapDispatchToProps)(Soal);